<template>
<div class="mt-8">
  <v-card outlined class="modern-card elevation-0 overflow-hidden">
    <v-sheet color="grey lighten-4" class="px-6 py-4 d-flex align-center border-bottom">
      <v-avatar size="32" color="orange lighten-4" class="mr-3">
        <v-icon small color="orange darken-3">fas fa-boxes</v-icon>
      </v-avatar>
      <div>
        <div class="caption orange--text text--darken-4 font-weight-black text-uppercase tracking-wider text-left">Registro de Consumos</div>
        <div class="text-subtitle-2 font-weight-bold grey--text text--darken-2">Materiales utilizados en este producto</div>
      </div>
      <v-spacer></v-spacer>
      <add-consumption :productId="productId" :work_order_id="work_order_id" @added="fetch"/>
    </v-sheet>

    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="5"
      :loading="loading"
      class="modern-table no-border-radius"
      hide-default-footer
      @page-count="pageCount = $event"
    >
      <template v-slot:no-data>
        <div class="pa-12 text-center grey--text lighten-2">
          <v-icon x-large class="mb-4 opacity-20">fas fa-box-open</v-icon>
          <div class="text-subtitle-1 font-weight-bold grey--text">Sin consumos registrados</div>
          <div class="caption grey--text opacity-70 mt-1">Haga clic en el botón superior para agregar un material.</div>
        </div>
      </template>

      <template v-slot:item.item="{ item, index }">
        <div class="d-flex align-center">
          <span class="caption grey--text font-weight-black">{{ index + 1 }}</span>
          <v-tooltip top v-if="item.reprocess">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="error" x-small class="ml-2">fas fa-redo-alt</v-icon>
            </template>
            <span>Consumo por reproceso</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:item.created_at="{ item }">
        <div class="body-2 font-weight-medium">{{ item.created_at | moment("DD/MM/YYYY") }}</div>
        <div class="caption grey--text">{{ item.created_at | moment("HH:mm") }} hrs</div>
      </template>

      <template v-slot:item.name="{ item }">
        <div class="d-flex align-center">
          <v-avatar size="28" color="primary lighten-5" class="mr-3">
            <v-icon x-small color="primary">fas fa-tag</v-icon>
          </v-avatar>
          <div>
            <div class="body-2 font-weight-black grey--text text--darken-3">{{ item.article.name }}</div>
            <div class="caption primary--text font-weight-black">{{ item.article.sku }}</div>
          </div>
        </div>
      </template>

      <template v-slot:item.qty="{ item }">
        <div class="text-right">
          <span class="body-1 font-weight-black primary--text">{{ item.qty | number('0,0.00') }}</span>
        </div>
      </template>

      <template v-slot:item.unitConsume="{ item }">
        <v-chip x-small label outlined color="grey darken-2" class="font-weight-black px-2">
          {{ item.unitConsume.toUpperCase() }}
        </v-chip>
      </template>

      <template v-slot:item.actions="{ item }">
        <div class="d-flex justify-center">
          <v-btn icon small color="error" class="grey lighten-4 shadow-sm" @click="confirmDelete(item)" title="Eliminar consumo">
            <v-icon x-small>fas fa-trash-alt</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
    
    <div class="pa-4 bg-grey-light border-top d-flex justify-center" v-if="items.length > 5">
       <v-pagination v-model="page" :length="pageCount" dense total-visible="7" color="primary" />
    </div>
  </v-card>

  <confirm 
    v-model="displayConfirmation" 
    :message="confirmationMessage"
    @ok="deleteComsumption"
    @cancel="displayConfirmation = false"
  />
</div>
</template>

<script>
import { fetchConsumtionBitacora, deleteConsumptionBitacora } from '@/api/production'
import AddArticle from '@/components/stocks/AddArticle'
import AddConsumption from './AddConsumption'
import notifications from '@/utils/notifications'

export default {
  name: 'ProductConsumptionDetail',
  props: ['productId', 'work_order_id'],
  components: { AddArticle, AddConsumption },
  data() {
    return {
      loading: false,
      items: [],
      headers: [
        { text: '#', value: 'item', align: 'left', width: '60' },
        { text: 'Fecha', value: 'created_at', align: 'left', width: '120' },
        { text: 'Artículo', value: 'name', align: 'left' },
        { text: 'Cant.', value: 'qty', align: 'right', width: '100' },
        { text: 'Unidad', value: 'unitConsume', align: 'left', width: '100' },
        { text: '', value: 'actions', align: 'center', width: '60', sortable: false },
      ],
      displayConfirmation: false,
      itemToDelete: null,
      confirmationMessage: ''
    }
  },
  methods: {
    fetch() {
      this.loading = true
      const query = `page=1&product=${this.productId}&ordering=created_at`
      fetchConsumtionBitacora(query)
      .then((res) => {
        this.items = res.results
      })
      .catch((e) => {
        notifications.showError(e)
      })
      .finally(() => {
        this.loading = false
      })
    },
    confirmDelete(item) {
      this.itemToDelete = item
      this.confirmationMessage = `¿Eliminar consumo de [${item.article.sku}] ${item.article.name} cantidad ${item.qty} ${item.unitConsume.toUpperCase()}?`
      this.displayConfirmation = true
    },
    deleteComsumption() {
      this.displayConfirmation = false
      deleteConsumptionBitacora(this.itemToDelete.id)
      .then((res) => {
        this.itemToDelete = null
        this.fetch()
        notifications.showSuccess('Consumo eliminado correctamente')
      })
      .catch((e) => {
        notifications.showError(e)
      })
      .finally(async () => {
        await this.$store.dispatch('fetchWorkOrderResume', this.work_order_id)
      })
    }
  },
  watch: {
    productId() {
      this.items = []
      this.fetch()
    }
  },
  created() {
    this.fetch()
  }
}
</script>

<style scoped>
.modern-card {
  border: 1px solid rgba(0,0,0,0.08) !important;
  border-radius: 12px !important;
}
.border-bottom {
  border-bottom: 1px solid rgba(0,0,0,0.08);
}
.border-top {
  border-top: 1px solid rgba(0,0,0,0.08);
}
.no-border-radius {
  border-radius: 0 !important;
}
.bg-grey-light {
  background-color: #f8f9fa;
}
.shadow-sm {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}
.opacity-20 { opacity: 0.2; }
.opacity-70 { opacity: 0.7; }
</style>